import { PureComponent } from "react";
import { StyledReviewsComponent } from "./reviews-component.scss";
import StarsComponent from "components/core/stars/stars-component";
import Review from "components/core/review/review";

export default class ReviewsComponent extends PureComponent {
  renderReviews() {
    const { columnWidth, reviews } = this.props;

    return reviews.map((review, index) => {
      return (
        <div key={index} className="review-component-wrapper" style={{ width: columnWidth }}>
          <Review {...review} />
        </div>
      );
    });
  }

  render() {
    return (
      <StyledReviewsComponent className="reviews-component">
        <div className="header-wrapper">
          <div className="stars-component-wrapper">
            <StarsComponent />
          </div>

          <div className="title">Why teams love monday.com</div>
        </div>
        <div className="reviews-wrapper">{this.renderReviews()}</div>
      </StyledReviewsComponent>
    );
  }
}

ReviewsComponent.defaultProps = {
  columnWidth: "350px",
  reviews: []
};
